import { RouteRecordRaw } from "vue-router";

import PastChampions from "./views/PastChampions.vue";
import Standings from "./views/Standings.vue";
import StandingsPreview from "./views/StandingsPreview.vue";
import WdlArchiveResults from "./views/WdlArchiveResults.vue";

export const routes: RouteRecordRaw[] = [
    {
        name: "results",
        path: "/results",
        component: WdlArchiveResults
    },
    {
        name: "standings",
        path: "/standings",
        component: Standings
    },
    {
        name: "standings-preview",
        path: "/standings-preview",
        component: StandingsPreview
    },
    {
        name: "past-champions",
        path: "/past-champions",
        component: PastChampions
    },
    { path: "/:catchAll(.*)", redirect: "/results" }
];
